export const SITE_URL = "https://hacyhb.cn";

export const siteConfig = {
  name: "黑料看点",
  brandMark: "黑料",
  brandMarkAccent: "看点",
  tagline: "每日精选，一页看完当日精华",
  description:
    "黑料看点聚焦全网文娱与网络热点，每日更新今日看点必看推荐，帮你省去在多平台翻找热点的时间。",
  keywords:
    "黑料看点,黑料看点每日精选,黑料看点今日看点,黑料看点每日更新,黑料看点必看",
  contactEmail: "editor@heiliaokandian.com",
  pressEmail: "tips@heiliaokandian.com",
  updatedAt: "每日 08:00 / 20:00 两次更新",
  foundedYear: 2021,
};

export const mainNav = [
  { label: "首页", to: "/" },
  { label: "今日看点", to: "/today" },
  { label: "主题分类", to: "/today#categories" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export const siteStats = [
  { label: "每日精选看点", value: "30+", icon: "ri-eye-line" },
  { label: "已更新期数", value: "1600", icon: "ri-calendar-check-line" },
  { label: "订阅读者", value: "12.6万", icon: "ri-user-heart-line" },
  { label: "覆盖内容分类", value: "6", icon: "ri-layout-grid-line" },
];

export const values = [
  {
    title: "每日更新，不拖更",
    desc: "每天早晚两次更新看点清单，热点出现后第一时间进入今日推荐，不让读者错过时间窗口。",
    icon: "ri-time-line",
  },
  {
    title: "人工筛选，拒绝信息噪声",
    desc: "编辑团队从多平台热点中筛掉标题党与低质重复内容，只保留真正值得看的部分。",
    icon: "ri-filter-3-line",
  },
  {
    title: "一页看完，节省时间",
    desc: "把分散在不同平台的看点整理成一页清单，配简短的看点摘要，几分钟就能掌握当日精华。",
    icon: "ri-file-list-3-line",
  },
  {
    title: "保持分寸，理性吃瓜",
    desc: "只围绕公开的作品、舞台与公开讨论展开，不传播未经证实的信息，不消费当事人隐私。",
    icon: "ri-shield-check-line",
  },
];

export const testimonials = [
  {
    name: "林小满",
    role: "追综三年 · 上海",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20studio%20portrait%20of%20a%20young%20asian%20woman%20with%20short%20hair%20in%20a%20warm%20neutral%20beige%20sweater%2C%20gentle%20natural%20window%20light%2C%20clean%20cream%20background%2C%20editorial%20lifestyle%20photography%2C%20high%20detail&width=200&height=200&seq=hlk-avatar-01&orientation=squarish",
    quote:
      "以前要在四五个平台之间来回翻，现在就早晚上来看一眼清单，当天有什么值得看的立刻心里有数，追综艺再也没漏过名场面。",
  },
  {
    name: "周叙",
    role: "剧集爱好者 · 成都",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20studio%20portrait%20of%20a%20young%20asian%20man%20wearing%20a%20simple%20olive%20shirt%2C%20calm%20expression%2C%20warm%20neutral%20background%2C%20natural%20soft%20light%2C%20editorial%20lifestyle%20photography%2C%20high%20detail&width=200&height=200&seq=hlk-avatar-02&orientation=squarish",
    quote:
      "选剧清单很对胃口，改编看点那一栏写得尤其实在，会直接告诉我原著粉最在意的点在哪，省了很多试错时间。",
  },
  {
    name: "苏禾",
    role: "内容运营 · 杭州",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20studio%20portrait%20of%20a%20young%20asian%20woman%20with%20long%20hair%20in%20a%20cream%20knit%20top%2C%20warm%20friendly%20smile%2C%20muted%20beige%20background%2C%20natural%20light%2C%20editorial%20lifestyle%20photography%2C%20high%20detail&width=200&height=200&seq=hlk-avatar-03&orientation=squarish",
    quote:
      "做内容选题的时候会来看深度观察栏目，角度比较克制，不追热度也不带节奏，找参考的时候很省心。",
  },
];

export const faqs = [
  {
    q: "黑料看点每天什么时候更新？",
    a: "我们每天更新两次：早上 08:00 发布当日「今日看点」清单，晚上 20:00 补充当天下午以来出现的新热点与名场面，保证你晚上刷到的也是最新内容。",
  },
  {
    q: "「今日看点」和「主题分类」有什么区别？",
    a: "今日看点按时间顺序汇总当天所有值得看的条目，适合快速扫一遍；主题分类则按综艺、影视、网络热点等方向长期沉淀内容，适合你想专心追某一类的时候逐条细看。",
  },
  {
    q: "看点内容是人工筛选还是自动抓取？",
    a: "两者结合。系统负责从公开渠道汇总候选热点，编辑团队再进行人工筛选与摘要撰写，剔除标题党和重复内容，最终呈现的清单都由真人过一遍。",
  },
  {
    q: "网站上的看点会不会涉及未经证实的传闻？",
    a: "不会。我们只围绕公开播出的作品、公开舞台与公开讨论展开，不传播未经核实的信息，也不消费当事人隐私。涉及争议话题时，我们会标注信息来源与时间。",
  },
  {
    q: "可以订阅每日看点吗？",
    a: "可以。在页面底部填写邮箱即可订阅「看点日报」，每天早上的精选清单会直接发到你的邮箱，随时可以退订。",
  },
  {
    q: "如何向你们推荐看点或提供线索？",
    a: "欢迎通过「联系我们」页面留言，或发送邮件到 editor@heiliaokandian.com。如果是想推荐某个有趣的热点，请在留言里附上链接与一句说明，方便我们快速判断。",
  },
];

export const principles = [
  "只呈现与公开作品、公开活动相关的内容，不传播隐私与未经核实的信息。",
  "每条看点标注来源与更新时间，方便读者自行判断。",
  "拒绝标题党，摘要尽量还原事件本身的重点。",
  "尊重当事人，争议话题保持克制，不做情绪化引导。",
];